// Approvals shown in the workflow card's approvals list (QA #12). Scoped to the current stage and
// to requests still pending or resolved to the CURRENT status; an APPROVED request is not listed -
// the status header already says it - while a rejected one stays so the reason remains visible.
// Only the latest request per approval_type counts (a resubmit creates a new request). It is picked
// BEFORE the status filter: an approved latest request hides the older rejection, which otherwise came
// back whenever the engagement re-entered the status that rejection was stamped with (QA #23).
import type { ApprovalRequestOut } from '@/redux/internal-services/workflowEngineApi';

export function visibleApprovals(
  all: ApprovalRequestOut[],
  ctx: { engagementId?: string | null; stageCode?: string | null; statusCode?: string | null },
): ApprovalRequestOut[] {
  const latestByType: Record<string, ApprovalRequestOut> = {};
  for (const a of all) {
    if ((ctx.engagementId && a.engagement_id !== ctx.engagementId) || a.stage_code !== ctx.stageCode) continue;
    const existing = latestByType[a.approval_type];
    if (!existing || new Date(a.requested_at).getTime() > new Date(existing.requested_at).getTime()) {
      latestByType[a.approval_type] = a;
    }
  }
  return Object.values(latestByType).filter((a) => a.status === 'pending'
    || (a.status === 'rejected' && !a.resolved_status_code) // fresh rejection: no status has stamped it yet (QA #23)
    || (a.status !== 'approved' && a.resolved_status_code === ctx.statusCode));
}
